<template>
  <v-app>
    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          scrollable
          max-width="1200"
      >
        <v-card>
          <v-toolbar dark>
            <v-card-title class="headline">
              Add resource category
              <hr>
            </v-card-title>

            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-spacer></v-spacer>
              <v-btn icon  @click="resetForm">
                <i class="fas fa-times"></i>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>


          <v-card-text >
            <v-container>
              <v-row v-for="(attachment, index) of attachments" :key="index">
                <v-col cols="6">
                  <v-select
                      v-model="attachment.type" item-text="text" item-value="value"
                      :items="[
                        {text:'Link',value:'link'},
                        {text:'File',value:'file'},
                      ]"
                      outlined
                      dense
                      label="Attachment Type"
                  ></v-select>
                </v-col>
                <v-col cols="3">
                  <v-switch v-model="attachment.is_downloadable" label="Downloadable"></v-switch>
                </v-col>
                <v-col cols="3">
                  <v-switch v-model="attachment.is_active" label="Status"></v-switch>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                      v-model="attachment.title"
                      outlined
                      dense
                      label="Title"
                  ></v-text-field>
                  <span class="text-danger" v-if="$v.attachments.$each[index].title.$error">This information is required</span>
                </v-col>
                <v-col cols="5" v-if="attachment.type =='file'">
                  <v-file-input
                      v-model="attachment.file_path "
                      outlined
                      dense
                      small-chips
                      label="Upload files related to resource"
                  ></v-file-input>
                  <span class="text-danger" v-if="attachment.type =='file' && $v.attachments.$each[index].title.$error">This information is required</span>
                </v-col>
                <v-col cols="5" v-else>
                  <v-text-field
                      v-model="attachment.file_path"
                      outlined
                      dense
                      label="Source link"
                  ></v-text-field>
                  <span class="text-danger" v-if="attachment.type =='link' && $v.attachments.$each[index].title.$error">This information is required</span>
                </v-col>
                <v-col cols="2">
                  <!--                <span @click="removeAttachment(index)"><i class="fas fa-trash"></i></span>-->
                </v-col>
              </v-row>
            </v-container>

            <!--            <v-row>-->
            <!--              <v-col cols="12" class="text-right">-->
            <!--                <span class="btn btn-primary" @click="addAttachment()">  <i class="fas fa-plus"></i></span>-->
            <!--              </v-col>-->
            <!--            </v-row>-->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                  class="btn  btn-standard text-gray cancel-btn"
                  depressed
                  @click="resetForm"
              >Cancel
              </v-btn>
              <v-btn
                  class="text-white btn btn-primary btn   font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
                  depressed
                  @click="validateForm"
                  :loading="isBusy"
              >Save
              </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</template>

<script>
import AttachmentService from "@/core/services/library/resource/AttachmentService";
import {required} from 'vuelidate/lib/validators'

const attachmentService = new AttachmentService()
export default {
  name: "Index",
  props: ['dialog', 'resource_id'],
  validations: {
    attachments: {
      required, $each: {
        title: {required},
        file_path: {required},
      }
    }
  },
  data() {
    return {
      attachment: [],
      attachments: [
        {
          title: null,
          file_path: null,
          library_resource_id: null,
          type: 'link',
          is_downloadable: 0,
          is_active: 1
        }
      ],
      isBusy: false,
      resource: {},
      type: 'link',
    }
  }, methods: {

    generateFd() {
      let fd = new FormData()
      this.attachments[0].library_resource_id = this.resource_id;
      this.attachments.forEach(ele => {
        for (let key in ele) {
          if (key == 'is_active' || key == 'is_downloadable') {
            fd.append(key + "[]", ele[key] ? 1 : 0)
          } else {

            fd.append(key + "[]", ele[key]);
          }
        }
      })
      return fd;
    },
    validateForm() {
      this.$v.attachments.$touch()
      if (this.$v.attachments.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 3000)
      } else {
        this.saveAttachment();
      }
    },
    saveAttachment() {
      let attachments = this.generateFd()
      this.isBusy = true;
      attachmentService.uploadAll(attachments).then(response => {
        this.$snotify.success("Successfully Created")
        this.resetForm();
      }).catch(error => {
        this.isBusy = false
      }).finally()
    },

    resetForm() {
      this.uploads = [];
      this.attachments = [];
      this.addAttachment()
      this.$emit('refresh_list')
    },

    addAttachment() {
      this.attachments.push({
        title: null,
        file_path: null,
        library_resource_id: this.resource.id,
        type: 'link',
        is_downloadable: 0,
        is_active: 1
      })
    }, removeAttachment(index) {
      this.attachments.splice(index, 1)
    },
  }
}
</script>

<style scoped>

</style>